import type { Mission } from '../missions.ts'

export const ssa: Mission = {
  id: "ssa",
  name: "Social Security Administration",
  short: "SSA",
  call: "Social Security",
  kind: "independent",
  url: "https://www.ssa.gov/",
  established: 1935,
  palette: {
    primary: "#002a5c",
    secondary: "#2378c3",
    accent: "#ce0e2d",
  },
  colorSource: {
    kind: "site",
    url: "https://www.ssa.gov/themes/custom/ssa_core/logo.svg",
  },
  motif: "eagle",
  mission: {
    text: "Deliver timely and accurate service through our digital-first capability while meeting customers where they choose.",
    url: "https://www.ssa.gov/agency/asp/materials/pdfs/SSA_Agency_Strategic_Plan_Fiscal_Years_2026-2030.pdf",
  },
  fact: {
    text: "President Roosevelt signed the Social Security Act into law on August 14, 1935.",
    url: "https://www.ssa.gov/history/briefhistory3.html",
  },
  seal: {
    file: "public/seals/ssa.svg",
    source: "https://www.ssa.gov/themes/custom/ssa_core/logo.svg",
  },
  identifier: {
    about: "https://www.ssa.gov/about-ssa",
    accessibility: "https://www.ssa.gov/accessibility/",
    foia: "https://www.ssa.gov/foia/",
    noFear: "https://www.ssa.gov/nofear/",
    oig: "https://oig.ssa.gov/",
    performance: "https://www.ssa.gov/agency/performance/",
    privacy: "https://www.ssa.gov/agency/privacy.html",
  },
  media: {
    photos: [
      {
        file: "/media/ssa-cohen-building.jpg",
        small: "/media/ssa-cohen-building-sm.jpg",
        alt: "The long limestone facade of the Wilbur J. Cohen Federal Building behind autumn trees under a clear blue sky.",
        title: "Wilbur J. Cohen Federal Building, built 1939-1940 as the Social Security Building, Washington, D.C., 2011",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Exterior_view_of_the_Wilbur_J._Cohen_Federal_Building,_Washington,_D.C_LCCN2013634387.tif",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
      {
        file: "/media/ssa-cohen-entrance.jpg",
        small: "/media/ssa-cohen-entrance-sm.jpg",
        alt: "The tall stripped-classical entrance of the Wilbur J. Cohen Federal Building, with bronze doors and flagpoles.",
        title: "Entrance, Wilbur J. Cohen Federal Building, originally the Social Security Building, Washington, D.C., 2011",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:Exterior_view_of_the_Wilbur_J._Cohen_Federal_Building,_Washington,_D.C_LCCN2013634389.tif",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
    ],
  },
}
